module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sildeShow),
      expression: "sildeShow"
    }],
    staticClass: "leftContent",
    class: {
      'silde-right': _vm.direction == 'right', 'silde-left': _vm.direction == 'left'
    }
  }, [_c('form', {
    attrs: {
      "id": "uploadForm"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "logo",
      "multiple": "multiple"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "headcon"
  }, [_c('img', {
    staticClass: "headpic",
    attrs: {
      "src": require("../../static/images/404.png")
    },
    on: {
      "click": function($event) {
        _vm.uploadPic()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.nickname))]), _vm._v(" "), _c('section', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "index-page"
  }, [_c('a', {
    staticClass: "sildeLeft ",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeDirection()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("首页")])])]), _vm._v(" "), _c('div', {
    staticClass: "mine-page"
  }, [_c('a', {
    staticClass: "sildeLeft ",
    attrs: {
      "href": "#/shoucang"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")]), _vm._v(" " + _vm._s(_vm.savePage ? '' : '收藏'))])]), _vm._v(" "), _c('div', {
    staticClass: "log-reg"
  }, [_c('a', {
    staticClass: "sildeLeft",
    attrs: {
      "href": "#/login"
    },
    on: {
      "click": _vm.clearCookie
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.logReg ? '退出' : '登录'))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "exit_silde_page"
  }, [_c('a', {
    staticClass: "exit_silde",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeDirection()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ask-help"
  }, [_c('a', {
    staticClass: "sildeLeft",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "#C0BFC4"
    },
    attrs: {
      "href": "#/connection"
    }
  }, [_vm._v("联系客服")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a058a0c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xsilde.vue
// module id = 248
// module chunks = 0